import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
import { ConnectionType } from '../../store/schema/ConnectionType';

export let updateAdvancedConnectionType = mutatorAction(
    'updateAdvancedConnectionType',
    (connectionType: ConnectionType) => {
        let store = connectedAccountsStore();
        store.connectAdvancedState.connectionType = connectionType;
        store.connectAdvancedState.incomingPort =
            connectionType === ConnectionType.ImapSmtp ? '993' : '995';

        if (connectionType === ConnectionType.SmtpOnly) {
            store.connectAdvancedState.remoteSend = true;
        }
    }
);
